import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BienesCulturalesService } from '../../bienes-culturales/bienes-culturales-list/bienes-culturales.service';
import { environment as env } from 'environments/environments';
import { Tipologia } from 'app/models/tipologias.model';
import { BehaviorSubject, map, Observable, startWith } from 'rxjs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BienesFilterParams } from '../../bienes-culturales/bienes-culturales-list/filtro/models/bienes-filter-params';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { ColeccionistasService } from '../coleccionistas.service';

@Component({
    selector: 'filtro-coleccionistas',
    templateUrl: 'filtro-coleccionistas.component.html',
    imports:[
        CommonModule, FormsModule, MatFormFieldModule, MatInputModule, MatAutocompleteModule, MatButtonModule,
        MatSelectModule,
                
    ]
})

export class FiltroColeccionistasComponent implements OnInit {
    tipology_departamentos:number= env.TIPOLOGIA_ID_DEPARTAMENTOS
    tipology_seccion:number = env.TIPOLOGIA_PADRE_ID_SECCION
    ColeccionistaFilters: Partial<BienesFilterParams>
    secciones:Tipologia[]
    todas:number= 0

    filter$ = new BehaviorSubject<string>('');
    allDepartamentos: Tipologia[] = [];
    departamentos$: Observable<Tipologia[]>;

    filterMunicipios$ = new BehaviorSubject<string>('');
    allMunicipios: Tipologia[] = [];
    municipios$: Observable<Tipologia[]>;
    @ViewChild('municipioInput') municipioInput!: ElementRef<HTMLInputElement>;

    constructor(private bienesService:BienesCulturalesService, private coleccionistasService:ColeccionistasService) { }

    ngOnInit() { 
        this.ColeccionistaFilters = {inicio:0, max:10};
        this.getDepartamento()
        this.getSeccion()
    }

    getDepartamento() {
        this.bienesService.getTipologias(this.tipology_departamentos).then((response: Tipologia[]) => {
            this.allDepartamentos = response;
    
            this.departamentos$ = this.filter$.pipe(
            startWith(''),
            map(query =>
                this.allDepartamentos.filter(d =>
                d.descripcion.toLowerCase().includes(query.toLowerCase())
                )
            )
            );
        });
    }
    
    displayFn(departamento: Tipologia): string {
        return departamento ? departamento.descripcion : '';
    }
    
    onDepartamentoInput(value: string): void {
        this.filter$.next(value);

        if (!value?.trim()) {
            delete this.ColeccionistaFilters.departamento
        }
    }

    getSeccion() {    
        this.bienesService.getTipologias(this.tipology_seccion)
            .then((response: Tipologia[]) => {
                this.secciones = response;
                this.ColeccionistaFilters.seccion = this.todas;
        });
    }

    filtrar(){
        this.coleccionistasService.getColeccionistas(this.ColeccionistaFilters)
        this.coleccionistasService.coleccionistasFilterParmas = this.ColeccionistaFilters
    }

    getMunicipios(event:Tipologia){ 
        if (this.ColeccionistaFilters.municipio) {
             this.municipioInput.nativeElement.value = '';
        }

        this.ColeccionistaFilters.departamento = event.tipologiaId;

        this.bienesService.getTipologias(event.tipologiaId)
        .then((response: Tipologia[]) => {
            this.allMunicipios = response;

            this.municipios$ = this.filterMunicipios$.pipe(
            startWith(''),
            map(query =>
                this.allMunicipios.filter(m =>
                m.descripcion.toLowerCase().includes(query.toLowerCase())
                )
            )
            );
        });
    }

    onMunicipioInput(value: string): void {
        this.filterMunicipios$.next(value);

        if (!value?.trim()) {
            delete this.ColeccionistaFilters.municipio;
        }
    }


    municipioSelected(event:Tipologia){
        this.ColeccionistaFilters.municipio = event.tipologiaId;
    }

}